var exports = {
  "k": "xaf9ae18d--608e51--container",
  "l": "xaf9ae18d--608e51--map-container",
};

module.exports = exports;
